export default {
  esg_dashboard: {
    title: 'Panel del control',
  },
  improvement_plans: {
    title: 'Plan de mejora',
  },
  question_group_section: {
    card_title: 'Encuestas sin responder',
    list_header_buyer_company_name: 'Empresas compradoras',
    list_header_question: '@:score_summary_section.list_header_question',
    list_header_deadline: 'Fecha límite',
    list_header_status: 'Estado',
    number_of_answered_label: 'Número de respuestas',
    // number_of_answered_unit: '',
    number_of_answered: 'Progreso： {answered}/{total}',
    status_re_answer_request: 'Solicitud de retiro en curso',
    answer: 'Respuesta',
    withdrawn: 'Retirado',
    // no_survey_response_requests_text_1:  '',
    // contact: '',
    // no_survey_response_requests_text_2: '',
  },
  score_summary_section: {
    card_title: '@:common.scorecard.title',
    list_header_buyer_company_name: 'Empresas compradoras',
    list_header_question: 'Cuestionario',
    list_header_create_at: 'Fecha de emisión',
    list_header_deadline: 'Fecha efectiva',
    list_header_status: 'Estado',
    limit_one_year: 'Un año a partir de la emisión',
    esg_score: 'Puntaje ESG',
    esg_rating: 'Calificación ESG',
    detail: 'Detalle',
  },
  faq_section: {
    card_title: 'Preguntas frecuentes',
    faq_why_request: {
      question:
        '¿Por qué mi empresa ha recibido de nuestro socio comercial una solicitud para someterse a la evaluación ESG de ASUENE?',
      answer:
        'En los últimos años, la contratación sostenible ha sido una tendencia importante, y se exige a las empresas que operen teniendo en cuenta los imperativos sociales relacionados con ESG a través de sus cadenas de suministro. En estos esfuerzos, las grandes empresas no sólo tienen que poner en marcha iniciativas ESG, sino que también tienen que animar a sus socios comerciales a hacerle frente a estas.',
    },
    faq_what_benefit: {
      question:
        '¿Cuáles son las ventajas de someterse a la evaluación ESG de ASUENE?',
      answer:
        'Hay tres ventajas de someterse a la evaluación ESG de ASUENE.\n1) Comprender las fortalezas y las mejoras de su empresa en materia de ESG\n2) Comparar la evaluación de su empresa con la de otras empresas de su sector\n3) Promover las iniciativas ESG de su empresa divulgando los resultados de la evaluación',
    },
    list: 'Ver lista',
  },
  contact_section: {
    card_title: 'Contacto',
    description:
      'Si tiene alguna pregunta sobre el cuestionario o sobre cómo responder, no dude en ponerse en contacto con nosotros en cualquier momento.Si desea recibir un apoyo más específico para mejorar sus iniciativas ESG, podemos organizar otro tipo de apoyo con consultores.',
    inquiry: 'Contacto',
  },
}
